// extracted by mini-css-extract-plugin
module.exports = {"toolsIcon":"styles_toolsIcon__3Okwd","btnJoin":"styles_btnJoin__2pXb6","material":"styles_material__34dnI","cursor":"styles_cursor__aBmJa"};